module.exports = __webpack_public_path__ + "img/bg-w-2.4c9a3bb4.png";